module.exports = __webpack_public_path__ + "img/file-icon.77e4bec6.png";